import React from "react";
import styled from "styled-components";

const PaginationStyles = styled.nav`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 40px !important;
  /* border: 2px solid var(--light-gray); */
  /* border-bottom-left-radius: 20px; */
  /* border-bottom-right-radius: 20px; */

  ul {
    white-space: pre;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
  }

  li {
    display: block;
    cursor: pointer;
    color: var(--cornflower);
    margin-right: 16px;
    transition: all ease 0.1s;

    /* &:hover {
      font-size: 20px;
      line-height: 25px;
    } */
  }

  .current-page {
    color: white;
    background: var(--off-black);
    line-height: 25px;
    width: 25px;
    text-align: center;
    border-radius: 100px;
    cursor: default;
    line-height: 25px;
    display: block;
  }

  .back-next {
    display: block;
    /* font-family: var(--header-font); */
    color: var(--cornflower);
    font-size: 32px;
    font-weight: normal;
    line-height: 23px;
    cursor: pointer;
    white-space: nowrap;
    margin-right: 20px;
    margin-left: 9px;

    /* &:hover {
      font-size: 20px;
      line-height: 25px;
    } */

    &:last-child {
      margin-right: 0;
      margin-left: 4px;
    }

    &:first-child {
      margin-left: 0;
    }

    &--disabled {
      display: none;
    }
  }

  .invisible {
    display: none;
  }

  .ellipsis {
    color: var(--off-black);
    cursor: default;
  }

  @media only screen and (max-width: 1145px) and (pointer: coarse) {
    width: calc(100vw - 24px);

    ul {
      white-space: pre;
      display: flex;
      flex-flow: row wrap;
      justify-content: center;
    }

    li {
      margin-right: 20px !important;
    }

    .back-next {
      &:last-child {
        margin-left: 0px;
      }
    }
  }
`;

const ResultsPagination = ({
  resultsPerPage,
  totalResults,
  paginate,
  currentPage,
}) => {
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(totalResults / resultsPerPage); i++) {
    pageNumbers.push(i);
  }

  const lastPage = pageNumbers.length;
  let displayedPages = [];

  //determine which pages to display
  const createDisplayedPages = () => {
    if (currentPage === 1 || currentPage === 2 || currentPage === 3) {
      displayedPages = [1, 2, 3, 4, "...", lastPage];
    } else if (
      currentPage === lastPage ||
      currentPage === lastPage - 1 ||
      currentPage === lastPage - 2
    ) {
      displayedPages = [
        1,
        "...",
        lastPage - 3,
        lastPage - 2,
        lastPage - 1,
        lastPage,
      ];
    } else {
      displayedPages = [
        1,
        "...",
        currentPage - 1,
        currentPage,
        currentPage + 1,
        "...",
        lastPage,
      ];
    }
  };

  //fill displayed pages array
  pageNumbers.length > 5
    ? createDisplayedPages()
    : (displayedPages = pageNumbers);

  return (
    <PaginationStyles>
      <nav className="pages">
        <ul className="pagination-list">
          <p
            onClick={() => {
              paginate("decrease");
            }}
            className={currentPage === 1 ? "back-next--disabled" : "back-next"}
          >
            &#x2039;
          </p>
          {displayedPages.map((number, index) => (
            //make sure even the ellipses have unique keys
            <li key={number === "..." ? number + index : number}>
              <p
                className={
                  number === currentPage
                    ? "current-page"
                    : typeof number === "string"
                    ? "ellipsis"
                    : undefined
                }
                onClick={() => {
                  if (number !== currentPage && typeof number !== "string")
                    paginate(number);
                  return;
                }}
              >
                {number}
              </p>
            </li>
          ))}
          <p
            onClick={() => {
              paginate("increase");
            }}
            className={
              currentPage === lastPage ? "back-next--disabled" : "back-next"
            }
          >
            &#x203A;
          </p>
        </ul>
      </nav>
    </PaginationStyles>
  );
};

export default ResultsPagination;
